import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 48443 55015"
    {...props}
  >
    <path
      d="M498 41534c1541 2513 5682 379 5443-2114 952-448 1892-939 2819-1460 2824 2477 7785-498 7046-4118 2374-1319 4793-2580 7086-4026-111 2687-7 5393 27 8088-3509 1154-3629 6940-77 8161 9 1063 49 2123 134 3172-2284 1030-2079 5685 868 5775 3538 108 4096-4527 1426-5706 131-1060 202-2127 243-3196 3521-1101 3698-6819 254-8138 106-2608 172-5239 154-7846 2121 1381 4343 2621 6525 3908-832 3599 4052 6701 6938 4298 914 544 1841 1059 2781 1531-304 2487 3783 4727 5388 2253 1929-2970-1752-5853-4145-4174-837-661-1708-1279-2601-1870 887-3581-3912-6699-6825-4438-2242-1486-4525-2951-6833-4324 2262-1208 4448-2581 6655-3895 2757 2458 7823-335 7101-4020 917-541 1813-1106 2679-1704 2035 1460 5962-1048 4564-3644-1678-3115-5969-1278-5654 1624-982 416-1941 889-2887 1389-2716-2497-7757 215-7172 3857-2206 1161-4409 2362-6562 3618 22-2488-31-4997-119-7485 3449-1301 3300-7020-215-8138-37-1070-102-2137-229-3197C27986 4548 27450-90 23912 2c-2947 76-3173 4730-895 5770-90 1049-135 2109-149 3172-3557 1204-3466 6990 37 8161-44 2548-150 5104-78 7648-2206-1371-4469-2688-6739-3957 679-3625-4291-6467-7070-4040-933-524-1880-1021-2852-1463 390-2892-3852-4840-5609-1768-1465 2559 2397 5167 4469 3759 849 621 1732 1209 2634 1773-816 3665 4177 6588 6996 4201 2164 1365 4304 2787 6527 4049-2312 1299-4601 2686-6850 4095-2854-2334-7731 660-6937 4262-908 567-1794 1163-2649 1802-2348-1739-6102 1049-4249 4068z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
